module.exports = __webpack_public_path__ + "static/biolau2-3dfb92a691ff2e7bc6dadda94fed77e9.jpg";